export const API_ROOT = 'https://lockers-qr-api.vacway.es/v1/'
export const GMAPS_KEY = 'AIzaSyB50fu9J8shwHYglxAjacSUreJkK9DWr2c'
